import { FC } from 'react';
import styles from '@/components/elems/Loading/Loading.module.scss';
import { LoadingPropsIF } from '@/components/elems/Loading/Loading.types';

const Loading: FC<LoadingPropsIF> = ({
    width,
    height,
    type = 'loader',
    className = '',
}) => (
    <div
        className={`flc ${className}`}
        style={{
            width: width ? `${width}px` : '100%',
            height: height ? `${height}px` : '300px',
        }}
    >
        <div className={styles[type]} />
    </div>
);

export default Loading;
